exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brew-list[data-v-62fe4a64] {\n  overflow: scrool;\n  height: 96vh;\n}\n.brew-list li[data-v-62fe4a64]:hover {\n  background-color: darkgrey;\n}", ""]);

// exports
